





































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Viewer from 'viewerjs'
import 'viewerjs/dist/viewer.css'
let viewer: any = ''
import ImageItem from '../AiiTasks/ImageItem.vue'
import VideoList from '../AiiTasks/videoList.vue'
import Task from '@/web-task'

@Component({
	components: {
		ImageItem,
		VideoList,
	},
})
export default class ImageInfo extends Vue {
	@Prop()
	private supplyInfo!: string

	@Prop()
	private injured: any

	@Prop()
	private order: any

	private task: any = ''

	@Watch('order', { immediate: true })
	private onOrderChange() {
		const task = new Task({
			propsData: {
				order: this.order,
				injured: this.injured,
				setting: this.$store.state.setting,
			},
		})
		this.task = task
	}

	private get needPlaceholder() {
		return (
			this.order.orderStatus <= '03' ||
			(this.order.orderStatus >= '06' && this.order.orderStatus < '16')
		)
	}

	private get mediaInfoMap() {
		const obj: any = {}
		if (this.injured.mediaInfoList && this.injured.mediaInfoList.length) {
			for (const i of this.injured.mediaInfoList) {
				if (!obj[i.type]) {
					obj[i.type] = []
				}
				obj[i.type].push(i)
			}
		}

		return obj
	}

	// 分散在各对象中的mediaInfo
	private get separateMediaMap() {
		const obj: any = {}
		if (this.injured.owner && this.injured.owner.mediaInfoList) {
			this.setMediaInfoMap(obj, 'owner', this.injured.owner.mediaInfoList)
		}
		if (this.injured.injuredList && this.injured.injuredList.length) {
			this.injured.injuredList.forEach((singleInjured: any, index: number) => {
				this.setMediaInfoMap(
					obj,
					`injuredList${index}`,
					singleInjured.mediaInfoList
				)
			})
		}
		return obj
	}

	private setMediaInfoMap(target: any, key: string, source: any) {
		target[key] = {}
		if (source && source.length) {
			for (const i of source) {
				if (!target[key][i.type]) {
					target[key][i.type] = []
				}
				target[key][i.type].push(i)
			}
		}
	}

	private getSignName(survey: any) {
		if (survey) {
			return survey.sign === '0' ? '拒绝签字' : survey.intervieweeName
		}
		return ''
	}

	private getURL(url: any) {
		if (url) {
			return url + '?imageMogr2/thumbnail/192x'
		} else {
			return ''
		}
	}

	@Watch('mediaInfoMap', { immediate: true })
	private onMapChange() {
		if (!this.injured.mediaInfoList) {
			return
		}
		this.$nextTick(() => {
			const wrapper2 = document.querySelector('#images')
			const options: any = {
				title(image: any) {
					return image.alt
				},
				url(image: any) {
					return image.src.replace(/\?imageMogr2\S+/, '')
				},
				toolbar: {
					oneToOne: {
						size: 'large',
					},
					reset: {
						size: 'large',
					},
					prev: {
						size: 'large',
					},
					play: {
						size: 'large',
					},
					next: {
						size: 'large',
					},
					rotateLeft: {
						size: 'large',
					},
					rotateRight: {
						size: 'large',
					},
				},
			}
			viewer && viewer.destroy()
			const wrapper: any = document.querySelector('#images')
			viewer = new Viewer(wrapper, options)
		})
	}
}
